import { useEffect, useState } from "react";
import type { StoreIndex } from "../data/store";

type State = {
    store: StoreIndex | null;
    loading: boolean;
    error: string | null;
};

/**
 * Fetches the canonical store (records + struct index, no struct content) once.
 * The frontend generates every language output from `store.patterns`.
 * Idempotent under StrictMode via the `ignore` flag.
 */
export function useStore(): State {
    const [state, setState] = useState<State>({
        store: null,
        loading: true,
        error: null,
    });

    useEffect(() => {
        let ignore = false;

        fetch("/api/store")
            .then((res) => {
                if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
                return res.json() as Promise<StoreIndex>;
            })
            .then((store) => {
                if (!ignore) setState({ store, loading: false, error: null });
            })
            .catch((err: unknown) => {
                if (!ignore) {
                    const message =
                        err instanceof Error ? err.message : "Failed to load";
                    setState({ store: null, loading: false, error: message });
                }
            });

        return () => {
            ignore = true;
        };
    }, []);

    return state;
}
